// Thin fetch layer. `authFetch` is optireach-web's `api<T>()`: attach the staff Bearer
// token, on 401 refresh once, retry once, then force the login screen.
import { AUTH_DISABLED, clearTokens, getAccessToken, refreshAccessToken } from './auth/useStaffAuth';

const API_BASE: string = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

/** authFetch: attach the staff Bearer token; on 401 → one silent refresh → one retry → force login. */
export async function authFetch<T = unknown>(path: string, init?: RequestInit): Promise<T> {
  const doFetch = (token: string | null): Promise<Response> =>
    fetch(apiUrl(path), {
      ...init,
      headers: {
        'content-type': 'application/json',
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        ...(init?.headers ?? {}),
      },
    });

  let res = await doFetch(AUTH_DISABLED ? null : getAccessToken());
  if (res.status === 401 && !AUTH_DISABLED) {
    const fresh = await refreshAccessToken();
    if (fresh) {
      res = await doFetch(fresh);
    } else {
      clearTokens(); // → App falls back to the login screen
    }
  }
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`${res.status} ${res.statusText} ${body.slice(0, 300)}`);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
